import BaseMfaVerifyCustomizer from './base';
import WebAuthnVerifyInfo from '../../components/mfa-verify/WebAuthnVerifyInfo';
import { AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT, MFA_CHALLENGE_EVENT_PREFIX } from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { enrolledFactorsDuringVerification, getOktaWidgetModel } from '../../utils/widget-facade';
import ProxyButton from '../../components/common/ProxyButton';
import { shouldDisplayResetAccountLink } from '../../utils/user-utils';
import Footer from '../../components/mfa-verify/Footer';

export default class MfaVerifyWebAuthnCustomizer extends BaseMfaVerifyCustomizer {
  async shouldCustomize() {
    return this.context?.controller === 'mfa-verify-webauthn';
  }

  protected forgifyController() {
    AmplitudeUtils.logMfaChallengeEvent(`Landing::${AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT[this.context.authenticatorKey]}FactorSelect`);
    this.forgifyVerifyInfo();
    this.forgifyVerifyButton();
    this.onFidoVerificationError();
    super.forgifyController();
  }

  protected getFooter({ footerLink }: { footerLink: JQuery }) {
    const moreThanOneFactorEnrolled = enrolledFactorsDuringVerification().length > 1;

    if (moreThanOneFactorEnrolled) {
      footerLink = footerLink.not('[data-se=cancel]');
    }
    return (
      <div className="fe_u_margin--top-large">
        <Footer
          text={this.footerText}
          footerLinks={footerLink.not('[data-se="cant-verify"]')}
          alwaysDisplayBackToSignIn={this.alwaysDisplayBackToLogin}
          displayResetAccountLink={shouldDisplayResetAccountLink()}
        />
      </div>
    );
  }

  private forgifyVerifyInfo() {
    const oktaVerifyText = jQueryCourage('.idx-webauthn-verify-text').parent()
      .hide();
    this.renderForgeAndHideOktaComponent({
      id: 'webauthn-verify-info',
      oktaComponent: oktaVerifyText,
      forgeComponent: <WebAuthnVerifyInfo />,
    });
  }

  private forgifyVerifyButton() {
    const retryButton = jQueryCourage('.retry-webauthn');
    this.renderForgeAndHideOktaComponent({
      id: 'webauthn-verify-button',
      oktaComponent: retryButton,
      forgeComponent: <ProxyButton oktaButton={retryButton} fullWidth />,
    });
  }
  private onFidoVerificationError() {
    const widgetModel = getOktaWidgetModel();
    widgetModel.on('error', (_: any, error: any) => {
      if (this.context?.controller === 'mfa-verify-webauthn') {
        AmplitudeUtils.logCustomEvent(`${MFA_CHALLENGE_EVENT_PREFIX}WebAuthn::Error`, { error });
      }
    });
  }
}
